var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-image-input border-0"},[_c('div',{staticClass:"image-input d-flex"},[_c('div',{staticClass:"m-auto"},[_c('upload-partial',{attrs:{"name":"csv-input","hide":['url', 'library'],"type":'small',"multiple":false,"accept":'csv'},on:{"change":_vm.fileChanged,"on-error":(driveError) => { _vm.error = driveError }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }